<template>
  <vs-sidebar
    click-not-close
    position-right
    parent="body"
    default-index="1"
    color="primary"
    class="add-new-data-sidebar items-no-padding"
    spacer
    v-model="isSidebarActiveLocal"
  >
    <div class="p-6 flex items-center justify-between bg-blue-dark">
      <h4 class="text-white">SUBPROYECTO</h4>
      <feather-icon
        icon="XIcon"
        @click.stop="isSidebarActiveLocal = false"
        class="cursor-pointer text-white"
      ></feather-icon>
    </div>
    <div class="my-0 h-2 bg-header-gradient"></div>

    <component
      :is="scrollbarTag"
      class="scroll-area--data-list-add-new"
      :settings="settings"
      :key="$vs.rtl"
    >
      <div class="p-6">
        <!--                <component v-bind:is="'CasoEdit'" :casoData="data" @changeMode="activateEditMode" @closeView="closeSidebar" @refresh="refreshData"></component>-->

        <SubproyectosCreateUpdate :propData="$props.data" :propModeCreate="$props.propModeCreate" :closeSidebar="closeSidebar"/>
      </div>
    </component>
  </vs-sidebar>
</template>

<script>
import VuePerfectScrollbar from 'vue-perfect-scrollbar'
import SubproyectosCreateUpdate from './SubproyectosCreateUpdate.vue'

export default {
  props: {
    isSidebarActive: {
      type: Boolean,
      required: true
    },
    propModeCreate: {
      type: Boolean,
      default: true
    },
    data: {
      type: Object,
      default: () => {}
    }
  },
  components: {
    VuePerfectScrollbar,
    SubproyectosCreateUpdate
  },
  data () {
    return {
      settings: {
        // perfectscrollbar settings
        maxScrollbarLength: 60,
        wheelSpeed: 0.6
      }
    }
  },
  created () {},
  watch: {
    isSidebarActive (val) {
      if (!val) return
      if (Object.entries(this.data).length === 0) {
        this.initValues()
        //this.$validator.reset()
      } else {
        const { category, id, img, name, order_status, price } = JSON.parse(
          JSON.stringify(this.data)
        )
        this.dataId = id
        this.dataCategory = category
        this.dataImg = img
        this.dataName = name
        this.dataOrder_status = order_status
        this.dataPrice = price
        this.initValues()
      }
      // Object.entries(this.data).length === 0 ? this.initValues() : { this.dataId, this.dataName, this.dataCategory, this.dataOrder_status, this.dataPrice } = JSON.parse(JSON.stringify(this.data))
    }
  },
  computed: {
    isSidebarActiveLocal: {
      get () {
        return this.isSidebarActive
      },
      set (val) {
        if (!val) {
          this.$emit('closeSidebar')
          this.initValues()
        }
      }
    },
    scrollbarTag () {
      return this.$store.getters.scrollbarTag
    }
  },
  methods: {
    initValues () {
    },
    closeSidebar () {
      this.$emit('closeSidebar')
      this.$validator.reset()
      this.initValues()
    }
  }
}
</script>

<style lang="scss" scoped>
.add-new-data-sidebar {
  ::v-deep .vs-sidebar--background {
    z-index: 51001;
  }

  ::v-deep .vs-sidebar {
    z-index: 51001;
    width: 90%;
    height: 95%;
    max-width: 1000vw;
    max-height: 1000vw;
    position: absolute;
    top: 0;
    bottom: 0;
    left: 0;
    right: 0;
    margin-top: auto;
    margin-bottom: auto;
    margin-left: auto;
    margin-right: auto;

    .img-upload {
      margin-top: 2rem;

      .con-img-upload {
        padding: 0;
      }

      .con-input-upload {
        width: 100%;
        margin: 0;
      }
    }
  }
}

.scroll-area--data-list-add-new {
  // height: calc(var(--vh, 1vh) * 100 - 4.3rem);
  height: 90%;

  &:not(.ps) {
    overflow-y: auto;
  }
}
</style>
